/* eslint import/prefer-default-export: 0 */
export const serviceConfig = {
  resourceBaseAddress: "https://qa2mer-api-go-nl.groupm.com/api"
};
